/** The `YYYY-MM-DD` of a local calendar day — the format the API and the URL take. */
export function toIsoDate(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${date.getFullYear()}-${month}-${day}`;
}

/** Midnight of the local calendar day, like the dates `fromIsoDate` returns. */
export function today(): Date {
    const now = new Date();

    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

/** The local calendar day of a `YYYY-MM-DD` string, or `null` when it isn't a real date. */
export function fromIsoDate(value: string | null): Date | null {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value ?? '');
    if (!match) {
        return null;
    }

    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));

    return toIsoDate(date) === value ? date : null;
}
